import {Injectable} from '@angular/core';
import {StorageService} from '../../original-services/storage.service';
import {ColorThemes, DefaultColorTheme} from '../../models/profile/color-theme.model';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ColorThemeService {

    public currentTheme$ = new BehaviorSubject<ColorThemes>(DefaultColorTheme)
    public mediaQuery = window.matchMedia('(prefers-color-scheme: light)');

    mediaListener = (e: any) => {
        this.selectAutoTheme(e.matches);
    }

    constructor(
        private storageService: StorageService
    ) {
    }

    setupColorTheme(theme = this.storageService.colorTheme): void {
        if (theme === ColorThemes.LIGHT) {
            this.setLightThemeStyle();
            this.mediaQuery.removeEventListener('change', this.mediaListener);
        } else if (theme === ColorThemes.DARK) {
            this.setDarkThemeStyle();
            this.mediaQuery.removeEventListener('change', this.mediaListener);
        } else {
            this.selectAutoTheme(this.mediaQuery.matches);
            this.mediaQuery.addEventListener('change', this.mediaListener);
        }
        this.currentTheme$.next(theme);
    }

    selectAutoTheme(isLight: boolean): void {
        if (isLight) {
            this.setLightThemeStyle();
        } else {
            this.setDarkThemeStyle();
        }
    }

    setLightThemeStyle(): void {
        const htmlElement = document.documentElement;
        if (htmlElement) {
            htmlElement.classList.remove('theme-dark');
            htmlElement.classList.add('theme-light');
        }
    }

    setDarkThemeStyle(): void {
        const htmlElement = document.documentElement;
        if (htmlElement) {
            htmlElement.classList.remove('theme-light');
            htmlElement.classList.add('theme-dark');
        }
    }

}
